import { render, staticRenderFns } from "./WarningTipRenderer.vue?vue&type=template&id=6513bbc6"
import script from "./WarningTipRenderer.vue?vue&type=script&lang=js"
export * from "./WarningTipRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports